import { CATEGORY_FACETS } from '@constants/categories';
import { useAppSelector } from '@redux/hooks';
import { GridColumn, GridRow } from '@tkww/orion-web-ds';
import { TextTitle } from '@tkww/orion-web-ds-text';
import type { Facet } from '@typings/Category';
import React from 'react';
import { FacetLink } from './FacetLink';
import Styles from './VenueFacetLinks.styles.scss';

const buildBase = (path: string) => {
	const [, base, category] = path.split('/');
	return base && category ? `/${base}/${category}` : '';
};

export const buildFacetHref = (
	base: string,
	{ cleanPath, facet }: Facet,
	sortSlug: string,
) => {
	const [, value] = facet.split('=');
	return cleanPath || (value && !value.includes('+'))
		? `${base}/${cleanPath || value}`
		: `${base}?${facet}${sortSlug}`;
};

export const VenueFacetLinks = () => {
	const city = useAppSelector((state) => state.location.city);
	const sort = useAppSelector((state) => state.search.sort);
	const path = useAppSelector((state) => state.requestInfo.path);
	const categoryCode = useAppSelector((state) => state.category.code);
	const sortSlug = sort ? `&sort=${sort}` : '';
	const base = buildBase(path);
	const categoryFacet = CATEGORY_FACETS[categoryCode];

	if (!categoryFacet || !base) {
		return null;
	}

	return (
		<>
			<GridRow>
				<GridColumn xs="12">
					<TextTitle size="sm" className={Styles.heading}>
						Explore other {categoryFacet.name.toLowerCase()} in {city}
					</TextTitle>
				</GridColumn>
			</GridRow>
			<GridRow>
				<GridColumn xs="12" className={Styles.links}>
					{categoryFacet.facets.map((link, index) => (
						<FacetLink
							key={link.facet}
							label={link.label}
							href={buildFacetHref(base, link, sortSlug)}
							isLastItem={index === categoryFacet.facets.length - 1}
						/>
					))}
				</GridColumn>
			</GridRow>
		</>
	);
};
